import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'environments/environment';
import { FacebookPixelService } from 'app/services/facebook-pixel.service';
import { TwitterPixelService } from './twitter-pixel.service';
import { RedditPixelService } from './reddit-pixel.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  referralCode: string = '';
  
  constructor(
    private _api: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private fbPixel: FacebookPixelService,
    private twitterPixel: TwitterPixelService,
    private redditPixel: RedditPixelService
  ) {
    this.checkAuthStatus();
    this.referralCode =
      this.route.snapshot.queryParamMap.get('referralCode') || '';
    const token = localStorage.getItem('access_token');
    if (token) {
      this.loadCustomer();
    }
  }

  private isAuthenticatedSubject = new BehaviorSubject<boolean>(false);
  isAuthenticated$ = this.isAuthenticatedSubject.asObservable();

  private showAuthOverlaySubject = new BehaviorSubject<boolean>(false);
  showAuthOverlay$ = this.showAuthOverlaySubject.asObservable();

  private authModeSubject = new BehaviorSubject<boolean>(false);
authMode$ = this.authModeSubject.asObservable();

  private customerSubject = new BehaviorSubject<any | null>(null);
  public customer$ = this.customerSubject.asObservable();

  private checkAuthStatus(): void {
    const token = localStorage.getItem('access_token');
    this.isAuthenticatedSubject.next(!!token);
  }

  updateAuthStatus(isAuthenticated: boolean): void {
    this.isAuthenticatedSubject.next(isAuthenticated);
  }

 showAuthOverlay(show: boolean, signup: boolean = false): void {
  this.showAuthOverlaySubject.next(show);
  this.authModeSubject.next(signup);
}
  // Sign Up Method
  signUp(payload: any): Observable<any> {
    return this._api.post(`auth/dealcustomersignup`, payload).pipe(
      map((response: any) => {
        if (response.success) {
          localStorage.setItem(
            'access_token',
            response.data?.accessToken?.token
          );
          localStorage.setItem(
            'customerId',
            response.data?.customer?.customerId
          );
          localStorage.setItem(
            'referralCode',
            response.data?.customer?.referralCode
          );
          setTimeout(() => {
            this.updateAuthStatus(true);
          }, 1000);
        }
        return response;
      })
    );
  }

  // Login Method
  login(payload: any): Observable<any> {
    return this._api.post(`auth/dealcustomerlogin`, payload).pipe(
      map((response: any) => {
        if (response.success) {
          localStorage.setItem(
            'access_token',
            response.data?.accessToken?.token
          );
          localStorage.setItem(
            'customerId',
            response.data?.customer?.customerId
          );
          localStorage.setItem(
            'referralCode',
            response.data?.customer?.referralCode
          );
          setTimeout(() => {
            this.updateAuthStatus(true);
            this.loadCustomer();
          }, 1000);
        }
        return response;
      })
    );
  }

  // Logout Method
  logout(): void {
    localStorage.removeItem('access_token');
    localStorage.removeItem('customerId');
    localStorage.removeItem('referralCode');
    this.customerSubject.next(null);
    this.showAuthOverlay(false);
    this.updateAuthStatus(false);
  }

  //social login
  socialLogin(payload: any): Observable<any> {
    const results = this._api
      .post(`auth/dealcustomersociallogin`, payload)
      .pipe(map((data) => data));
    return results;
  }

  // Request password reset OTP
  requestPasswordResetOTP(email: string): Observable<any> {
    return this._api.post(`auth/ForgotPassword`, {
      Email: email,
    });
  }

  // Verify OTP
  verifyOTP(Email: string, otp: string): Observable<any> {
    return this._api.post(`auth/VerifyOTP`, {
      Email,
      OTP: otp,
    });
  }

  // Reset password with verified OTP
  resetPassword(
    OTP: string,
    email: string,
    newPassword: string
  ): Observable<any> {
    return this._api.post(`auth/ResetPassword`, {
      OTP,
      Email: email,
      NewPassword: newPassword,
    });
  }

  getCustomerById(customerId: number): Observable<any> {
    const results = this._api
      .get(`Customer/${customerId}`)
      .pipe(map((data) => data));
    return results;
  }

   updateCustomerBankDetails(bankAccountNumber: string, bankAccountSortCode: string): Observable<any> {
    return this._api.post(`Customer/UpdateBankDetails`, {
      bankAccountNumber,
      bankAccountSortCode,
    });
  }
updateCustomerDob(dob: string): Observable<any> {
  return this._api.postWithHeaders('Customer/UpdateCustomerDob', `"${dob}"`);
}



  updateCutsomerDeliveryAddress(
    payload: any,
    customerId: number
  ): Observable<any> {
    const results = this._api
      .post(
        `CustomerDeliveryAddress/SaveDeliveryAddress?customerId=${customerId}`,
        payload
      )
      .pipe(map((data) => data));
    return results;
  }

  closeDealAccount(customerId: number): Observable<any> {
    const results = this._api
      .post(`auth/closedealaccount`, { customerId })
      .pipe(map((data) => data));
    return results;
  }

  setAutomatedDealEmails(
    customerId: number,
    automatedDealEmails: boolean
  ): Observable<any> {
    const results = this._api
      .post(`Customer/SetAutomatedDealEmails`, {
        customerId,
        automatedDealEmails,
      })
      .pipe(map((data) => data));
    return results;
  }

  handleGoogleAuthCallback() {
    this.route.queryParams.subscribe((params) => {
      const authCode = params['code'];
      const state = params['state'];
      let returnUrl = '';

      // Extract return URL from state if available
      if (state) {
        try {
          const stateObj = JSON.parse(decodeURIComponent(state));
          returnUrl = stateObj.returnUrl || '';
        } catch (e) {
          console.error('Error parsing state parameter:', e);
        }
      }

      if (authCode) {
        this.socialLogin({
          Provider: 'google',
          code: authCode,
          ReferralCode: this.referralCode,
        }).subscribe(
          (response) => {
            if (response.success) {
              const accessToken = response.data?.jwToken?.token;
              localStorage.setItem('access_token', accessToken);
              localStorage.setItem(
                'customerId',
                response.data?.customer?.customerId
              );
              localStorage.setItem(
                'referralCode',
                response.data?.customer?.referralCode
              );
              if (response.data?.customer?.isNewUser) {
                this.fbPixel.trackCompleteRegistration();
                this.twitterPixel.trackCompleteRegistration(
                  response.data?.customer?.customerEmailAddress,
                  response.data?.customer?.customerId
                );
                this.redditPixel.trackSignUp(
                  response.data?.customer?.customerId,
                  response.data?.customer?.customerEmailAddress
                );
              }
              this.updateAuthStatus(true);
              this.clearRouteQueryParams();

              // Navigate back to the return URL if available
              if (returnUrl) {
                // Extract path from URL properly
                try {
                  // Create a URL object to easily parse the URL
                  const urlObj = new URL(returnUrl);

                  // Get the pathname and search parts (path + query params)
                  const urlPath = urlObj.pathname + urlObj.search;

                  this.router.navigateByUrl(urlPath);
                } catch (e) {
                  console.error('Error parsing return URL:', e);
                  // Fallback to just navigating home
                  this.router.navigate(['/']);
                }
              }
              this.showAuthOverlay(false);
              this.loadCustomer();
            } else {
              this.toastr.error(response.message || 'Login with Google failed');
              console.error('Social login failed:', response.message);
            }
          },
          (error) => {
            console.error('Social login error:', error);
            this.updateAuthStatus(false);
            this.clearRouteQueryParams();
            this.toastr.error('Error signing in with Google');
          }
        );
      }
    });
  }


    
signUpWithFacebook() {
  const appId = environment.facebookClientId; // Facebook App ID
  const redirectUri = environment.facebookRedirectUri;
  const scope = 'email,public_profile';
  const responseType = 'code';
  const state = encodeURIComponent(JSON.stringify({
    returnUrl: window.location.href
  }));

  window.location.href =
    `https://www.facebook.com/v19.0/dialog/oauth` +
    `?client_id=${appId}` +
    `&redirect_uri=${redirectUri}` +
    `&response_type=${responseType}` +
    `&scope=${scope}` +
    `&state=${state}`;
}

  handleFacebookAuthCallback() {
  this.route.queryParams.subscribe((params) => {
    const authCode = params['code'];
    const state = params['state'];
    let returnUrl = '';

    if (state) {
      try {
        const stateObj = JSON.parse(decodeURIComponent(state));
        returnUrl = stateObj.returnUrl || '';
      } catch (e) {
        console.error('Error parsing state parameter:', e);
      }
    }

    if (authCode) {
      this.socialLogin({
        Provider: 'facebook',
        code: authCode,
        ReferralCode: this.referralCode
      }).subscribe(
        (response) => {
          if (response.success) {
            const accessToken = response.data?.jwToken?.token;
            localStorage.setItem('access_token', accessToken);
            localStorage.setItem('customerId', response.data?.customer?.customerId);
            localStorage.setItem('referralCode', response.data?.customer?.referralCode);

            if (response.data?.customer?.isNewUser) {
              this.fbPixel.trackCompleteRegistration();
              this.twitterPixel.trackCompleteRegistration(
                response.data?.customer?.customerEmailAddress,
                response.data?.customer?.customerId
              );
              this.redditPixel.trackSignUp(
                response.data?.customer?.customerId,
                response.data?.customer?.customerEmailAddress
              );
            }

            this.updateAuthStatus(true);
            this.clearRouteQueryParams();

            if (returnUrl) {
              try {
                const urlObj = new URL(returnUrl);
                const urlPath = urlObj.pathname + urlObj.search;
                this.router.navigateByUrl(urlPath);
              } catch {
                this.router.navigate(['/']);
              }
            }
            this.showAuthOverlay(false);
            this.loadCustomer();
          } else {
            this.toastr.error(response.message || 'Login with Facebook failed');
          }
        },
        (error) => {
          console.error('Social login error:', error);
          this.updateAuthStatus(false);
          this.clearRouteQueryParams();
          this.toastr.error('Error signing in with Facebook');
        }
      );
    }
  });
}


  signUpWithGoogle() {
    const clientId = environment.googleClientId;
    const redirectUri = environment.googleRedirectUri;
    const scope = 'openid email profile';
    const responseType = 'code';
    const currentUrl = this.getCurrentUrl();
    const state = encodeURIComponent(JSON.stringify({ returnUrl: currentUrl }));
    window.location.href = `https://accounts.google.com/o/oauth2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}&access_type=offline&prompt=consent&state=${state}`;
  }




  private getCurrentUrl(): string {
    return window.location.href;
  }

  clearRouteQueryParams() {
    const currentRoute = this.router.url.split('?')[0];
    this.router.navigateByUrl(currentRoute, { replaceUrl: true });
  }

  checkEmailExists(Email: string): Observable<any> {
    return this._api
      .post(`auth/customeremailcheck`, { Email })
      .pipe(map((response: any) => response));
  }

  loadCustomer(): void {
    const customerId = Number(localStorage.getItem('customerId'));
    if (!customerId) return;

    this.getCustomerById(customerId).subscribe(
      (response) => {
        const customer = response?.result;
        if (customer) {
          this.customerSubject.next(customer);
        }
      },
      (error) => {
        console.error('Failed to load customer data:', error);
      }
    );
  }
}
